import { CircleCheckIcon, InfoIcon, Loader2Icon, OctagonXIcon, TriangleAlertIcon } from "lucide-react"
import { Toaster as Sonner, type ToasterProps } from "sonner"

import { useTranslation } from "react-i18next"

import { useTheme } from "@/lib/theme"

/** Toasts: bottom-start (right in RTL, left in LTR), 4 s, success/danger (spec §4.9). */
const Toaster = (props: ToasterProps) => (
  <ThemedSonner {...props} />
)

function ThemedSonner(props: ToasterProps) {
  const theme = useTheme()
  const { i18n } = useTranslation()
  const dir = i18n.dir()
  return (
  <Sonner
    theme={theme}
    dir={dir}
    position={dir === "rtl" ? "bottom-right" : "bottom-left"}
    duration={4000}
    mobileOffset={{ bottom: "84px" }}
    className="toaster group"
    icons={{
      success: <CircleCheckIcon className="size-4 text-brand-700" />,
      info: <InfoIcon className="size-4 text-info" />,
      warning: <TriangleAlertIcon className="size-4 text-warning" />,
      error: <OctagonXIcon className="size-4 text-danger" />,
      loading: <Loader2Icon className="size-4 animate-spin" />,
    }}
    toastOptions={{ classNames: { toast: "font-sans text-sm", title: "font-semibold" } }}
    style={
      {
        "--normal-bg": "var(--popover)",
        "--normal-text": "var(--popover-foreground)",
        "--normal-border": "var(--border)",
        "--border-radius": "var(--radius-md)",
      } as React.CSSProperties
    }
    {...props}
  />
  )
}

export { Toaster }
